import React from 'react';
import { Link } from 'react-router-dom';

function BookingWidget({ isEnglish }) {
  const bookingPath = isEnglish ? '/en/booking' : '/booking';
  const lookupPath = isEnglish ? '/en/lookup' : '/lookup';

  return (
    <div style={{ width: '100%', padding: '60px 0', backgroundColor: 'transparent' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>

        {/* カードコンテナ（白背景＋金茶ボーダー＋影） */}
        <div style={{
          backgroundColor: '#fff',
          padding: '50px 40px',
          borderRadius: '8px',
          textAlign: 'center',
          boxShadow: '0 10px 30px rgba(8, 7, 82, 0.05)',
          border: '1px solid #e0d8c0'
        }}>

          <h2 style={{
            margin: '0 0 15px 0',
            fontSize: '1.8rem',
            fontFamily: '"Noto Serif JP", serif',
            color: '#080752',
            letterSpacing: '0.08em'
          }}>
            {isEnglish ? 'Reserve Your Stay' : '空室確認・ご予約'}
          </h2>

          <p style={{
            margin: '0 0 30px 0',
            color: '#555',
            fontSize: '0.98rem',
            lineHeight: '1.6'
          }}>
            {isEnglish
              ? 'Book directly through our official website for the best rate guaranteed. You can also easily check, modify, or cancel your reservations online.'
              : '公式サイトからのご予約が最もお得です（ベストレート保証）。ご予約後の確認・変更・キャンセル等の手続きもオンラインでスムーズに行えます。'}
          </p>

          {/* メリットタグ */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '24px',
            flexWrap: 'wrap',
            marginBottom: '40px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#333', fontSize: '0.9rem', fontWeight: '500' }}>
              <span style={{ color: '#c2a87c' }}>✓</span> {isEnglish ? 'Best Rate Guaranteed' : 'ベストレート保証'}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#333', fontSize: '0.9rem', fontWeight: '500' }}>
              <span style={{ color: '#c2a87c' }}>✓</span> {isEnglish ? 'Instant Confirmation' : '即時予約確定'}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#333', fontSize: '0.9rem', fontWeight: '500' }}>
              <span style={{ color: '#c2a87c' }}>✓</span> {isEnglish ? 'Easy Modification' : 'オンライン変更・キャンセル対応'}
            </div>
          </div>

          {/* ボタンエリア（横並び / スマホ時は折り返し） */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            flexWrap: 'wrap'
          }}>
            {/* 新規予約ボタン */}
            <Link
              to={bookingPath}
              style={{
                display: 'inline-block',
                backgroundColor: '#080752',
                color: '#ffffff',
                padding: '16px 48px',
                borderRadius: '4px',
                fontSize: '1.05rem',
                fontWeight: 'bold',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(8, 7, 82, 0.2)',
                letterSpacing: '0.05em'
              }}
              className="booking-cta-btn primary-btn"
            >
              {isEnglish ? 'Check Availability →' : '空室状況・ご予約手続きへ →'}
            </Link>

            {/* 確認・キャンセル・変更ボタン */}
            <Link
              to={lookupPath}
              style={{
                display: 'inline-block',
                backgroundColor: 'transparent',
                color: '#080752',
                border: '1px solid #080752',
                padding: '16px 32px',
                borderRadius: '4px',
                fontSize: '1.05rem',
                fontWeight: 'bold',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                letterSpacing: '0.05em'
              }}
              className="booking-cta-btn secondary-btn"
            >
              {isEnglish ? 'Manage / Change Booking' : 'ご予約の確認・変更・キャンセル'}
            </Link>
          </div>
        </div>
      </div>

      {/* ホバー時のアニメーションスタイル */}
      <style>{`
        .booking-cta-btn.primary-btn:hover {
          background-color: #1a1873 !important;
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(8, 7, 82, 0.3) !important;
        }
        .booking-cta-btn.secondary-btn:hover {
          background-color: #fdfbf7 !important;
          transform: translateY(-2px);
        }
      `}</style>
    </div>
  );
}

export default BookingWidget;